export default __webpack_public_path__ + "static/media/key-fill.c4f6cc8c.svg";